// Copyright (c) 2022 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.mikholap@celadon.ae>
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import moment from 'moment';

import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames/bind';

import styles from './styles';
import history from '../../services/history';

import schedule from '../../images/schedule.png';


class Voucher extends Component {
  state = {};

  static propTypes = {
    classes: PropTypes.object,
    voucher: PropTypes.object,
  };

  static defaultProps = {
    classes: {},
    voucher: {},
  };

  onRedeem = (event) => {
    event.preventDefault();
    event.stopPropagation();
    history.push('/account/vouchers/redeem', {
      code: this.props.voucher.Code,
      bookshopCustomerId: this.props.voucher.BookshopCustomerId,
    });
  }

  render() {
    const {
      classes,
      voucher,
    } = this.props;

    const balance = parseFloat(voucher.Balance);
    const expired = !!voucher.ExpiryDate && moment(voucher.ExpiryDate).isBefore(moment());
    const canRedeem = balance > 0 && !expired;
    const cannotRedeemReason = expired
      ? `This voucher expired on ${moment(voucher.ExpiryDate).format('DD/MM/YYYY')}`
      : 'Nothing left on this voucher';

    return (
      <div className={classes.container}>
        <div className={classes.dateTimeContainer}>
          <p className={classes.dateTimeText}>
            {`${moment(voucher.IssueDate).format('D MMM YYYY')}`}
          </p>
          <p className={classes.dateTimeText}>
            {`${moment(voucher.IssueDate).format('hh.mm')}`}
          </p>
        </div>
        <div className={classes.imageContainer}>
          <div className={classes.imageInnerContainer}>
            <img alt={'schedule'} className={classes.image} src={schedule} />
          </div>
          <div className={classes.line} />
        </div>
        <Link
          className={classes.infoContainer}
          to={{
            pathname: `/account/vouchers/customer-overview/${voucher.BookshopCustomerId}`,
            state: { bookshopCustomerId: voucher.BookshopCustomerId }
          }}
        >
          <div className={classes.rowContainer}>
            <p className={classes.descText}>Customer</p>
            <p className={classes.text}>{`${voucher.FullName}`}</p>
          </div>
          <div className={classes.rowContainer}>
            <p className={classes.descText}>Email</p>
            <p className={classes.text}>{`${voucher.Email}`}</p>
          </div>
          <div className={classes.rowContainer}>
            <p className={classes.descText}>Gift card no</p>
            <p className={classes.text}>{`${voucher.Code}`}</p>
          </div>
          <div className={classes.rowContainer}>
            <p className={classes.descText}>Value</p>
            <p className={classes.text}>{`${parseFloat(voucher.IssueValue).toFixed(2)}`}</p>
          </div>
          <div className={classes.rowContainer}>
            <p className={classes.descText}>Items</p>
            <p className={classes.text}>{`${voucher.ItemsCount}`}</p>
          </div>
          <div className={classes.rowContainer}>
            <p className={classes.descText}>Expires</p>
            <p className={classes.text}>
              {voucher.ExpiryDate ? moment(voucher.ExpiryDate).format('DD/MM/YYYY') : '-'}
            </p>
          </div>
          <div className={classes.rowContainer}>
            <p className={classes.descText}>Remaining balance</p>
            {/* Plain, like every other row. This used to render in
                COLOR_REJECT - the colour the rest of the app uses for
                rejected items - which read as a warning about a voucher that
                is in perfectly good order. */}
            <p className={classes.text}>
              {`${parseFloat(voucher.Balance).toFixed(2)}`}
            </p>
          </div>
          <div className={classNames(classes.rowContainer, classes.mobileDateContainer)}>
            <p className={classes.descText}>Date</p>
            <p className={classes.text}>
              {`${moment(voucher.IssueDate).format('D MMM YYYY hh.mm')}`}
            </p>
          </div>
          <div className={classes.redeemContainer}>
            <button
              type={'button'}
              disabled={!canRedeem}
              title={canRedeem ? undefined : cannotRedeemReason}
              className={classNames(classes.redeemButton, !canRedeem && classes.redeemButtonDisabled)}
              onClick={this.onRedeem}
            >
              REDEEM
            </button>
          </div>
        </Link>
      </div>
    );
  }
}

export default (withStyles(styles)(Voucher));
